module.exports = __webpack_public_path__ + "static/img/img6.63b7b6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/img6.png
// module id = SQZS
// module chunks = 1